window.addEventListener('beforeunload', () => {
	sessionStorage.setItem('scrollPosition', window.scrollY.toString());
});

function lenisAnimation() {
	return new Promise((resolve) => {
		const lenis = new Lenis({
			duration: 1.2,
			smooth: true,
			smoothTouch: false,
		});

		gsap.ticker.add((time) => {
			lenis.raf(time * 1000);
		});

		ScrollTrigger.scrollerProxy(document.documentElement, {
			scrollTop(value) {
				return arguments.length ? lenis.scrollTo(value, { immediate: true }) : lenis.scroll;
			},
			getBoundingClientRect() {
				return {
					top: 0,
					left: 0,
					width: window.innerWidth,
					height: window.innerHeight,
				};
			},
			pinType: 'fixed',
		});

		lenis.on('scroll', ScrollTrigger.update);

		setTimeout(() => {
			ScrollTrigger.refresh();
			resolve();
		}, 300);

		// console.log('Lenis básico iniciado.');
	});
}

export { lenisAnimation };
